import { fromPairs, get, map, pipe } from 'lodash/fp';

export const normalise = (payload) =>
  pipe(
    get('resources'),
    map((r) => [get('family', r), get('resource', r)]),
    fromPairs,
  )(payload);
